import * as React from "react";

const Assignments: React.FC<React.SVGProps<SVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="31"
    fill="none"
    viewBox="0 0 31 31"
  >
    <path
      stroke="#313131"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M11.625 4.844H6.781v23.25H24.22V4.844h-4.844m-9.687 15.5h11.625m-7.75-1.938v3.875m-3.876-7.75h11.626m-3.875-1.937v3.875M11.625 6.78l-.969-3.875h9.688l-.969 3.875z"
    ></path>
  </svg>
);

export default React.memo(Assignments);
